export function escapeHtml(value: string): string {
  return value
    .replaceAll("&", "&amp;")
    .replaceAll("<", "&lt;")
    .replaceAll(">", "&gt;")
    .replaceAll('"', "&quot;")
    .replaceAll("'", "&#039;");
}

export function iconArrow(direction: "right" | "left" | "up" = "right"): string {
  const rotation = direction === "left" ? 180 : direction === "up" ? -90 : 0;
  return `<svg aria-hidden="true" viewBox="0 0 24 24" class="icon" style="transform:rotate(${rotation}deg)"><path d="M5 12h13M13 6l6 6-6 6" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
}

export function iconShare(): string {
  return `<svg aria-hidden="true" viewBox="0 0 24 24" class="icon"><path d="M12 16V3m0 0L7.5 7.5M12 3l4.5 4.5M5 12v7.5h14V12" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
}

export function iconDownload(): string {
  return `<svg aria-hidden="true" viewBox="0 0 24 24" class="icon"><path d="M12 3v12m0 0l-4-4m4 4l4-4M5 19h14" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
}
